import { Home, Match } from '@/domain';

export type SharedStateType = {
  userData: Home | null;
  matches: any;
  authToken: string;
  browserEnv?: Record<string, string> | null;
};

export const SharedState: SharedStateType = {
  userData: null,
  matches: null,
  authToken: '',
  browserEnv: null,
};

export const resetSharedState = () => {
  SharedState.userData = null;
  SharedState.matches = null;
  SharedState.authToken = '';
};

export const findChatById = (chatId: number) => {
  return (
    SharedState.matches?.list_new.find((el: Match) => el.id === chatId) ||
    SharedState.matches?.list_open.find((el: Match) => el.id === chatId)
  );
};

export const removeMatchById = (matchId: number) => {
  if (SharedState.matches) {
    SharedState.matches.list_new = SharedState.matches.list_new.filter(
      (el: Match) => el.id !== matchId
    );
    SharedState.matches.list_open = SharedState.matches.list_open.filter(
      (el: Match) => el.id !== matchId
    );
  }
};

export const exportFromNewToOpen = (matchId: number) => {
  if (SharedState.matches) {
    const match = SharedState.matches.list_new.find(
      (el: Match) => el.id === matchId
    );
    if (match) {
      SharedState.matches.list_new = SharedState.matches.list_new.filter(
        (el: Match) => el.id !== matchId
      );
      SharedState.matches.list_open.push(match);
    }
  }
};
